import { SignedIn } from '@clerk/clerk-react';

/**
 * Minimal account page. Extend with purchase history, settings, etc.
 */
export default function Account() {
  return (
    <SignedIn>
      <div className="flex flex-col gap-6">
        <h1 className="text-3xl font-semibold">Account</h1>
        <p className="text-slate-600 dark:text-slate-400">
          Your account details. Add purchase history, receipts, or other features here.
        </p>
      </div>
    </SignedIn>
  );
}
